import BaseIvrNode, { EMPTY_ERROR_ID_MESSAGE } from './baseIvrNode';
import { IsNotEmpty, IsString, ValidateNested, IsOptional } from 'class-validator';
import { Type } from 'class-transformer';

export default class VariableMatchNode extends BaseIvrNode {
  @ValidateNested({ each: true })
  @Type(() => VariableMatch)
  variableMatches: VariableMatch[];

  @IsString()
  @IsNotEmpty({ message: 'Please select the default next node the customer will go to' })
  defaultNextId: string;

  @IsString()
  @IsNotEmpty({ message: EMPTY_ERROR_ID_MESSAGE })
  errorNodeId: string;
}

class VariableMatch {
  @IsString()
  expression: string;

  @IsString()
  @IsNotEmpty({ message: 'Please enter a valid regular expression' })
  pattern: string;

  @IsString()
  @IsOptional()
  nextId?: string;
}
